/* © CNES */
import { AuthenticationResolution } from './AuthenticationResolution';

/**
 * Not Authenticated Result.
 */
export type NotAuthenticatedResult = {
  status: typeof AuthenticationResolution.notAuthenticated;
};
/**
 * Authenticated Result.
 */
export type AuthenticatedResult = {
  status: typeof AuthenticationResolution.authenticated;
  login: { name: string; email: string; token: SessionToken | null };
};
/**
 * Authentication Status.
 */
export type AuthenticationStatus = NotAuthenticatedResult | AuthenticatedResult;
/**
 * Default value for not authenticated (stable reference for redux).
 */
export const notAuthenticatedStatus: NotAuthenticatedResult = {
  status: AuthenticationResolution.notAuthenticated,
};
/**
 * Session Token.
 */
export type SessionToken = {
  value: string;
  expiresInMS: number;
};
